import React, { type ReactElement } from 'react';
import { LimitData, type LimitProperty } from '../limit-data';
import LimitMessage from './view';

export const ATLASSIAN_SUPPORT_URL = 'https://support.atlassian.com/contact';

export type Props = {
	numUsed: number;
	limitProperty: LimitProperty;
	renderNearLimitMessage: (limit: number) => string;
	renderNearLimitDescription: (limit: number) => ReactElement;
	renderAtLimitMessage: (limit: number) => string;
	renderAtLimitDescription: (limit: number) => ReactElement;
	renderOverLimitMessage: (limit: number) => string;
	renderOverLimitDescription: (limit: number) => ReactElement;
	onMessageRendered: () => void;
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (props: Props) => (
	<LimitData limitProperty={props.limitProperty}>
		{(limit: number) => <LimitMessage limit={limit} {...props} />}
	</LimitData>
);
